import styled, { createGlobalStyle } from "styled-components";

export const BodyNoScroll = createGlobalStyle`
body {
	overflow-y: hidden;
	position: fixed;
	width: 100%;
}
body::-webkit-scrollbar {
	display: none;
}
`;

export const RegisterYourInterestWrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 9;
  --accentColor: ${(props) =>
    props.accentColor ? props.accentColor : "var(--purple)"};
`;

export const RegisterYourInterestScrim = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(16, 24, 32, 0.4);
`;

export const RegisterYourInterestFormDiv = styled.div`
  position: relative;
  width: 490px;
  padding: 25px 45px;
  margin-left: auto;
  margin-right: auto;
  z-index: 999;
  top: 100px;
  background-color: var(--white);
  & > svg {
    position: absolute;
    right: 33px;
    top: 33px;
  }
  & h1 {
    color: var(--accentColor);
    margin: 0 0 20px 0;
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 0.32px;
    font-weight: 600;
  }
  & > form div {
    display: flex;
    justify-content: space-between;
    & > label {
      color: var(--text);
      width: 190px;
      font-size: 15px;
      line-height: 21px;
      font-weight: 500;
      letter-spacing: 0.3px;
      & > input {
        width: 190px;
      }
    }
  }
  & label {
    color: var(--text);
    font-weight: 500;
    & input {
      display: block;
      width: 100%;
      margin-bottom: 20px;
      margin-top: 5px;
      height: 36px;
      font-size: 15px;
      padding: 4px;
      font-family: var(--headerFont);
      line-height: 21px;
      font-weight: 400;
      letter-spacing: 0.3px;
    }
    & input[type="email"] {
      width: 384px;
    }
  }
  & .textarea {
    width: 100%;
    & label {
      width: 100%;
      font-weight: 500;
      & textarea {
        width: 100%;
        margin-top: 5px;
        padding: 4px;
        font-family: var(--headerFont);
        line-height: 21px;
        font-weight: 400;
        letter-spacing: 0.3px;
        height: 64px;
      }
    }
  }
  & input[type="submit"] {
    color: var(--accentColor);
    border: 1px solid var(--accentColor);
    width: 200px;
    height: 36px;
    font-family: var(--headerFont);
    font-size: 15px;
    font-family: var(--headerFont);
    line-height: 21px;
    font-weight: 500;
    margin-top: 35px;
    margin-bottom: 10px;
    background-color: var(--white);
  }
  @media (max-width: 767px) {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: scroll;
    max-width: 100%;
    & label input[type="email"] {
      width: 100%;
    }
    & > form div {
      flex-direction: column;
      & > label {
        width: 100%;
        & > input {
          width: 100%;
        }
      }
    }
  }
  @media (max-height: 880px) {
    max-height: calc(100vh - 100px);
    max-height: 100vh;
    padding-bottom: 100px;
    overflow-y: scroll;
  }
`;
